import React from 'react';

export const navigationItems = [
  { 
    id: 'customer', 
    label: 'Customer Information', 
    icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' 
  },
  { 
    id: 'timeline', 
    label: 'Timeline & Milestones', 
    icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' 
  },
  { 
    id: 'pricing', 
    label: 'Pricing & Products', 
    icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' 
  },
  { 
    id: 'details', 
    label: 'Additional Details', 
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' 
  }
];

interface ProposalNavigationProps {
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
}

export const ProposalNavigation: React.FC<ProposalNavigationProps> = ({
  activeSection,
  onSectionChange
}) => {
  return (
    <nav className="space-y-2">
      {navigationItems.map(item => (
        <button
          key={item.id}
          onClick={() => onSectionChange(item.id)}
          className={`w-full flex items-center px-3 py-2.5 rounded-lg text-left transition-colors whitespace-nowrap ${
            activeSection === item.id 
              ? 'bg-primary text-white'
              : 'text-text-grey hover:bg-page-bg'
          }`}
        >
          <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
          </svg>
          <span className="text-sm font-medium truncate">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}; 